export default __webpack_public_path__ + "static/media/VirtualTwilight1.69f9756d.png";